import landingImage from "../assets/images/prabhusir.jpg";

const LandingSection = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center gap-10">
        
        {/* Left Column - Image */}
        <div className="md:w-1/2 flex justify-center md:justify-start">
          <div className="relative group">
            <img
              src={landingImage}
              alt="Employee Management Dashboard"
              className="rounded-2xl shadow-2xl w-full max-w-md transform transition duration-300 group-hover:scale-105"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent rounded-2xl"></div>
          </div>
        </div>

        {/* Right Column - Content */}
        <div className="md:w-1/2 space-y-6">
          {/* Small Label */}
          <div className="inline-block bg-blue-100 text-blue-700 px-4 py-1.5 rounded-full text-sm font-medium">
            Meet Our Leadership
          </div>

          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Prabhu Nayak – 
            <span className="text-blue-600 block mt-1">
              Chief Executive Officer
            </span>
          </h1>

          {/* Bio */}
          <div className="space-y-4 text-gray-600">
            <p className="leading-relaxed">
              Prabhu Nayak joins the company as Chief Executive Officer, bringing over 16 years of extensive experience in the software industry. He has a strong background in building and scaling technology solutions, leading high-performing teams, and driving business growth across diverse domains.
            </p>
            
            <p className="leading-relaxed">
              With deep expertise in software development, operations, and strategic leadership, Prabhu has successfully delivered innovative solutions that align technology with business goals. His leadership is focused on fostering innovation, operational excellence, and customer-centric growth.
            </p>
            
            <p className="leading-relaxed font-medium text-gray-800">
              As CEO, Prabhu Nayak is leading the development of our next-generation <span className="text-blue-600">Employee Management System</span>—an AI-powered platform that revolutionizes how businesses manage their workforce.
            </p>
          </div>

          {/* Key Initiatives */}
          <div className="grid grid-cols-2 gap-3 pt-4">
            <div className="flex items-center gap-2 text-sm">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span>AI-Powered HR Solutions</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span>Global Workforce Management</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span>Intelligent Automation</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span>Data-Driven Insights</span>
            </div>
          </div>

          {/* CTA */}
          <div className="pt-4">
            <button className="group flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition">
              Learn more about our EMS platform
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingSection;